module.exports = __webpack_public_path__ + "media/packs/users/img/footer/fa-phone-alt-solid-850dbeac9dc63d72f52630db374df2cb.svg";